/**
 * @file External Album Upload main component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import UploadProgress from './UploadProgress';
import Button from '../global/Button';
import Spinner from '../global/Spinner';
import UploaderRecommendations from '../../apps/pro/components/UploaderRecommendations';
import { photoUploadFilter } from '../../util/photo-upload';

class ExternalAlbumUpload extends Component {
  static propTypes = {
    albumUploadReset: PropTypes.func.isRequired,
    albumUpload: PropTypes.func.isRequired,
    total: PropTypes.number,
    current: PropTypes.number,
    success: PropTypes.bool,
    error: PropTypes.string,
    album: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
    }),
  };

  static defaultProps = {
    total: 0,
    current: 0,
  };

  componentDidMount() {
    this.props.albumUploadReset();
  }

  onFileInputChange = event => {
    const files = [...event.target.files];

    const photos = files.filter(photoUploadFilter);

    this.props.albumUpload(photos);
  };

  onSuccessButtonClick = () => {
    const { albumUploadReset } = this.props;

    albumUploadReset();
  };

  render() {
    const { total, current, error, success, albumUploadReset, album } =
      this.props;

    if (!album) {
      return (
        <div className="flex-auto text-center mt-5">
          <Spinner />
        </div>
      );
    }

    if (!album.enable_external_upload) {
      const redirectToError = {
        pathname: '/error',
        state: {
          error: 'Selected album does not support external uploads',
        },
      };

      return <Redirect to={redirectToError} />;
    }

    return (
      <div className="uploader-wrap">
        <label htmlFor="uploader" className="uploader">
          <p className="mb-1">
            Drag &amp; drop photos here or browse your files
          </p>
          <p className="mb-4 text-sm">
            Photos will be added to the{' '}
            <strong className="text-dark">album {album.name}</strong>
          </p>

          <Button className="uploader-button">Browse Files</Button>

          <input
            id="uploader"
            type="file"
            accept="image/*"
            onChange={this.onFileInputChange}
            multiple
          />

          <UploaderRecommendations />
        </label>

        <UploadProgress
          total={total}
          current={current}
          success={success}
          error={error}
          visible={!!total}
          onDismiss={albumUploadReset}
          onSuccessButtonClick={this.onSuccessButtonClick}
        />
      </div>
    );
  }
}

export default ExternalAlbumUpload;
